import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Condition} from '../../../../../../ispm-web/shared/modules/common';
import {EntityTreeService} from './entity-tree.service';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

export const CONDITION_RESOURCE_TYPE: string = 'condition';

@Injectable()
export class ConditionService {

  constructor(private service: EntityTreeService, private routerManagerService: RouterManagerService) {
  }

  create(name: string, additionalProperties: { [prop: string]: any }): Observable<Condition> {
    return of(null);
  }

  search(searchParams: { [key: string]: string }): Observable<Array<Condition>> {
    return (this.service.search(CONDITION_RESOURCE_TYPE, searchParams) as Observable<Array<Condition>>);
  }

  update(Condition: Condition): Observable<Condition> {
    return of(null);
  }

  get(ConditionId: string): Observable<Condition> {
    return of(null);
  }

  searchCurrentPatient(): Observable<Array<Condition>> {
    return this.search({context: this.routerManagerService.parameters.patientId});
  }

}
